import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { Strings } from "../Stores/StringsStore";

@observer
export class RejectButton extends Button {

	render() {
		return <Button {...this.props} title={Strings.general.cancel}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<polygon points="31.71 3.12 28.88 0.29 16 13.17 3.12 0.29 0.29 3.12 13.17 16 0.29 28.88 3.12 31.71 16 18.83 28.88 31.71 31.71 28.88 18.83 16 31.71 3.12" />
				</svg>
			</i>
		</Button>;
	}
}
